import React, {useEffect} from "react";
import PropTypes from "prop-types";
import "./styles.scss";
import TextBody from "canvas-core-react/lib/TextBody";
import TextHeadline from "canvas-core-react/lib/TextHeadline";
import SecondaryButton from "canvas-core-react/lib/SecondaryButton";
import PrimaryButton from "canvas-core-react/lib/PrimaryButton";
import ModalOverlay from "../modal-overlay/modal-overlay";

const Modal = ({
                   Description,
                   title,
                   buttonLabel,
                   action,
                   footer = null,
                   secondButtonLabel = null,
                   secondAction = null,
                   secondButtonType = "",
               }) => {
    useEffect(() => {
        document.body.classList.add("modal-open");
        return () => {
            document.body.classList.remove("modal-open");
        };
    }, []);

    return (
        <ModalOverlay>
            <div id="title-container">
                <TextHeadline component="div" className="modal__text" size="small">
                    {title}
                </TextHeadline>
            </div>
            <div id="description-container">
                {typeof Description === "string" ? (
                    <TextBody component="p" type="2">
                        {Description}
                    </TextBody>
                ) : (
                    <Description/>
                )}
            </div>
            <div className="button-container">
                {footer || (
                    <>
                        {secondAction
                            ? SecondAction(secondAction, secondButtonLabel)
                            : null}
                        <PrimaryButton id="button-person-result" onClick={action}>
                            {buttonLabel}
                        </PrimaryButton>
                    </>
                )}
            </div>
        </ModalOverlay>
    );
};

const SecondAction = (action, label) => {
    return (
        <SecondaryButton
            type={"inverted"}
            id="button-second-action"
            onClick={action}
        >
            {label}
        </SecondaryButton>
    );
};

Modal.propTypes = {
    buttonLabel: PropTypes.string.isRequired,
    action: PropTypes.func.isRequired,
    title: PropTypes.node.isRequired,
};

Modal.defaultProps = {
    title: "",
};
export default Modal;
